import {
    PERSONALIZATION
} from "../../constants/actionTypes";

const INIT_STATE = {
    isLoading: false,
    alertMessage: '',
    messageId: null,
    lists: [],
    personalizationsCount: null,
    giftCalculation: null,
};


export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case PERSONALIZATION.PERSONALIZATION_RESET: {
            return {
                ...state,
                isLoading: false,
                alertMessage: '',
                messageId: null
            }
        }

        case PERSONALIZATION.LIST_PERSONALIZATION_REQUEST: {
            return {
                ...state,
                isLoading: true
            }
        }

        case PERSONALIZATION.LIST_PERSONALIZATION_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                messageId: 200,
                lists: action.payload
            }
        }

        case PERSONALIZATION.LIST_PERSONALIZATION_FAIL: {
            return {
                ...state,
                isLoading: false,
                alertMessage: action.payload.message,
                messageId: 203
            }
        }

        case PERSONALIZATION.PERSONALIZATION_COUNT_REQUEST: {
            return {
                ...state,
                loader: true
            }
        }

        case PERSONALIZATION.PERSONALIZATION_COUNT_SUCCESS: {
            return {
                ...state,
                loader: false,
                personalizationsCount: action.payload
            }
        }

        case PERSONALIZATION.PERSONALIZATION_COUNT_FAIL: {
            return {
                ...state,
                loader: false,
                alertMessage: action.payload.message
            }
        }

        case PERSONALIZATION.SEARCH_PERSONALIZATION_REQUEST: {
            return {
                ...state,
                loader: true
            }
        }

        case PERSONALIZATION.SEARCH_PERSONALIZATION_SUCCESS: {
            return {
                ...state,
                loader: false,
                messageId: 200,
                lists: action.payload
            }
        }

        case PERSONALIZATION.SEARCH_PERSONALIZATION_FAIL: {
            return {
                ...state,
                loader: false,
                alertMessage: action.payload.message,
                messageId: 203
            }
        }

        case PERSONALIZATION.GIFT_ITEM_COUNT_REQUEST: {
            return {
                ...state,
                loader: true
            }
        }

        case PERSONALIZATION.GIFT_ITEM_COUNT_SUCCESS: {
            return {
                ...state,
                loader: false,
                giftCalculation: action.payload
            }
        }

        case PERSONALIZATION.GIFT_ITEM_COUNT_FAIL: {
            return {
                ...state,
                loader: false,
                alertMessage: action.payload.message
            }
        }

        default:
            return state;
    }
}
